import { Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';

const path = PAGE_PATHS.AGENTIC_SOC;

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/agentic-soc/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
